import { useEffect, useState } from "react";
import { Outlet, useNavigate, Navigate } from "react-router-dom";
import { styled, Container, Box } from "@mui/material";
import {
  WorkspaceSidebar,
  WORKSPACE_ACCENT_COLORS,
  SIDEBAR_WIDTH,
} from "@/layouts/full/sidebar";
import { useSelector, dispatch } from "@/redux/store";
import { handlingRoles } from "@/redux/apps/users/UserSlice";
import HeaderLayout from "@/layouts/landing/header/Header";
import { setCookie } from "@/utils";
import { getProductConfigForSubdomain } from "@/utils/helpers";
import { applicationTitle, getSubdomain } from "@/utils/common";
import { COMMON_SUB_DOMAIN, MASTER_SUB_DOMAIN } from "@/config";
import { Helmet } from "react-helmet-async";

const MainWrapper = styled("div")(() => ({
  display: "flex",
  minHeight: "100vh",
  width: "100%",
  //background: 'rgba(255, 255, 255, 0.30)',
  backgroundColor: "#e6e8ec",
  overflow: "auto"
}));

const PageWrapper = styled("div")(() => ({
  display: "flex",
  flexGrow: 1,
  paddingBottom: "43px",
  flexDirection: "column",
  zIndex: 1,
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  backgroundColor: "transparent",
  overflowX: "hidden",
}));

const CreateLayout = () => {
  const navigate = useNavigate();
  const title = applicationTitle();
  const subDomain = getSubdomain();

  const { loggedUserOrganisations } = useSelector((state) => state.user);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [isOrgFetched, setIsOrgFetched] = useState<boolean>(false);
  useEffect(() => {
    if (
      loggedUserOrganisations &&
      loggedUserOrganisations?.length === 1 &&
      !isOrgFetched &&
      !selectedItem
    ) {
      handleOrganizationSelect(loggedUserOrganisations[0]);
      setIsOrgFetched(true);
    }
  }, [loggedUserOrganisations]);

  const handleOrganizationSelect = async (selected: any) => {
    if (selected) {
      await dispatch(
        handlingRoles({
          roles: loggedUserOrganisations
        })
      );
      setSelectedItem(selected);
      setCookie("xsm_user_organization", JSON.stringify(selected));
      navigate("/dashboard");
    }
  };

  const isAuthenticatedLandingLayout = () => {
    const subDomain = getSubdomain();
    const defaultSubDomain =
      subDomain !== "" && subDomain !== COMMON_SUB_DOMAIN ? subDomain : "xsm";
    const accessTokenKey = `${defaultSubDomain}_access_token`;
    // Check for subdomain-specific token first, then fallback to generic token
    const accessToken =
      localStorage.getItem(accessTokenKey) || localStorage.getItem("xsm_access_token");
    return !!accessToken;
  };

  const productConfig = getProductConfigForSubdomain(subDomain);
  const Icon = productConfig?.icon;
  const productDisplayName = productConfig?.displayName ?? title;
  const workspaceAccentColor = productConfig?.accentColor ?? WORKSPACE_ACCENT_COLORS.partner;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <MainWrapper>
        {isAuthenticatedLandingLayout() ? (
          <>
            <WorkspaceSidebar
              navItems={[]}
              onSelect={() => undefined}
              workspaceName={productDisplayName}
              workspaceIconSrc={Icon}
              workspaceAccentColor={workspaceAccentColor}
              shimmerEffect={true}
              disabledLink={true}
            />
            <PageWrapper
              className="page-wrapper"
              style={{
                marginLeft: `${SIDEBAR_WIDTH}px`,
                width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
              }}
            >
              <HeaderLayout
                isDropdownOpen={true}
                dropdownItems={loggedUserOrganisations}
                handleDropdownSelect={handleOrganizationSelect}
              />
              <Container
                maxWidth={false}
                sx={{ padding: 0, margin: 0, maxWidth: "100%", width: "100%" }}
              >
                <Box
                  sx={{
                    minHeight: "calc(100vh - 170px)",
                    width: "100%",
                    maxWidth: "100%",
                    minWidth: 0,
                  }}
                >
                  <Outlet />
                </Box>
              </Container>
            </PageWrapper>
          </>
        ) : (
          <Navigate to="/" replace />
        )}
      </MainWrapper>
    </>
  );
};

export default CreateLayout;
